import { useEditorPresence } from '@/hooks/use-editor-presence';
import { PainelConfirmDialog } from '@/components/painel/PainelFeedbackDialog';

export function EditorPresenceWatcher() {
  const { peers, showWarning, dismiss, label } = useEditorPresence();

  const names = peers.map((p) => p.name || p.username).filter(Boolean);
  const who =
    names.length === 0
      ? 'outro editor'
      : names.length === 1
        ? names[0]
        : `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;

  const pageLabel = label ? `«${label}»` : 'esta página';

  return (
    <PainelConfirmDialog
      open={showWarning}
      onOpenChange={(open) => {
        if (!open) dismiss();
      }}
      tone="info"
      title="Alguém já está a editar"
      description={
        <>
          <strong className="font-semibold text-white">{who}</strong> já está a editar {pageLabel}.
          Se ambos guardarem, as alterações mais recentes podem sobrescrever as outras. Coordene
          com a equipa ou continue com cuidado.
        </>
      }
      confirmLabel="Continuar mesmo assim"
      cancelLabel="Entendi"
      onConfirm={dismiss}
    />
  );
}
